import React from 'react';

const NuclearAwardInfoModal = ({ isOpen, onClose, isDarkMode }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex justify-center items-center z-[150] p-4 backdrop-blur-sm transition-all duration-300"
      onClick={onClose}
    >
      <div 
        className={`rounded-2xl shadow-2xl p-6 max-w-md w-full border transition-all duration-300 transform scale-100 ${
          isDarkMode 
            ? "bg-zinc-900 border-zinc-800 text-zinc-100" 
            : "bg-white border-gray-150 text-gray-900"
        }`}
        onClick={e => e.stopPropagation()}
      >
        
        {/* Top Section Header */}
        <div className="mb-4">
          <h3 className="text-xl font-black mt-1 bg-gradient-to-r from-brand-pink to-purple-500 bg-clip-text text-transparent">
            Nuclear Certifications
          </h3>
        </div>

        <div className="space-y-4">
          
          {/* Core Concept Block */}
          <p className="text-xs opacity-70 leading-relaxed font-medium">
            Nuclear Certifications recognize milestone achievements for your songs based on actual, physical downloads initiated by your fans via tipping interactions.
          </p>
          
          {/* Requirement Warning Check - Styled exactly like other dashboard warning panels */}
          <div className={`p-3.5 rounded-xl border text-xs leading-relaxed ${
            isDarkMode 
              ? "bg-zinc-950/50 border-zinc-800/80" 
              : "bg-gray-50 border-gray-150"
          }`}>
            <p className="font-extrabold text-brand-pink flex items-center space-x-1.5 mb-1.5 text-[11px] uppercase tracking-wider">
              
              <span>Requirement Check</span>
            </p>
            <p className="opacity-75 font-medium text-[11px]">
              You must ensure the <strong className="font-bold">"Disable AUD Downloads"</strong> checkbox is unticked in your song editing options. If active, fans cannot trigger the download events needed to progress.
            </p>
          </div>

          {/* Milestone List Container */}
          <div className={`p-4 rounded-xl border space-y-3.5 ${
            isDarkMode ? "bg-zinc-950/30 border-zinc-850/60" : "bg-gray-50/50 border-gray-100"
          }`}>
            
            {/* Radium */}
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <span className="text-[9px] font-black uppercase tracking-wider bg-emerald-400/10 text-emerald-400 px-2.5 py-1 rounded-lg border border-emerald-400/20 block min-w-[75px] text-center">
                  Radium
                </span>
              </div>
              <span className="text-[11px] font-semibold opacity-80">
                Requires <strong className="font-bold">10 unique downloads</strong> triggered by tipping fans.
              </span>
            </div>

            {/* Plutonium */}
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <span className="text-[9px] font-black uppercase tracking-wider bg-amber-400/10 text-amber-400 px-2.5 py-1 rounded-lg border border-amber-400/20 block min-w-[75px] text-center">
                  Plutonium
                </span>
              </div>
              <span className="text-[11px] font-semibold opacity-80">
                Requires <strong className="font-bold">50 unique downloads</strong> triggered by tipping fans.
              </span>
            </div>

            {/* Uranium */}
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <span className="text-[9px] font-black uppercase tracking-wider bg-pink-500/10 text-brand-pink px-2.5 py-1 rounded-lg border border-brand-pink/20 block min-w-[75px] text-center">
                  Uranium
                </span>
              </div>
              <span className="text-[11px] font-semibold opacity-80">
                Requires <strong className="font-bold">100 unique downloads</strong> triggered by tipping fans.
              </span>
            </div>

          </div>
        </div>

        {/* Dynamic Glowing Action Button */}
        <button
          onClick={onClose}
          type="button"
          className="mt-6 w-full bg-brand-pink text-white font-bold py-3.5 px-4 rounded-xl shadow-lg shadow-brand-pink/25 hover:scale-[1.01] active:scale-[0.98] transition-all duration-200 text-xs uppercase tracking-widest"
        >
          Got It
        </button>

      </div>
    </div>
  );
};

export default NuclearAwardInfoModal;